import { useStore } from '@tanstack/react-form'
import { ForwardedRef, forwardRef } from 'react'

import { VendiaFormApi } from './form'

export type ErrorMessageProps = {
  name: string
  form: VendiaFormApi<any>
  hasErrors: boolean
}

const ErrorMessage = ({ form, name, hasErrors }: ErrorMessageProps, ref: ForwardedRef<HTMLDivElement>) => {
  const fieldMeta = useStore(form.store, (state: any) => state.fieldMeta[name])

  if (form && hasErrors) {
    return (
      <div className='mt-1 select-none text-xs text-red-600' ref={ref}>
        {fieldMeta?.errors[0]}
      </div>
    )
  }
  return null
}

export default forwardRef(ErrorMessage)
